import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import DataStore from '../../stores/DataStore';
import cn from 'classnames';

import styles from './home.css';

import CircleButton from '../../components/CircleButton/CircleButton';
import Letters from '../../components/Letters/Letters';
import ProfileNav from '../../components/ProfileNav/ProfileNav';
import HomeHelmet from './Helmet';

class Home extends Component {

	constructor(props) {
    super(props);

    this.state = {
      isToggleOn: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    this.data = DataStore.getPageBySlug('home');
    this.match = this.props.match;
  }

  handleClick() {
    this.setState(prevState => ({
    	isToggleOn: !prevState.isToggleOn
    }));
  }

	render() {
    const className = cn(styles.content, {
      [styles.isActive]: this.state.isToggleOn
    });

		return (
	    <section className={className}>
        <HomeHelmet />
	    	<CircleButton handler={this.handleClick} isActive={this.state.isToggleOn} />
        <Letters isToggleOn={this.state.isToggleOn} />
        <ProfileNav data={this.data} isToggleOn={this.state.isToggleOn} />
	    </section>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home/Home.js